import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { nexusApi } from "@/lib/nexusApi";

const NexusContext = createContext(null);

export function NexusProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = signed out

  const refresh = useCallback(async () => {
    try { const { data } = await nexusApi.get("/me"); setUser(data); return data; }
    catch { setUser(false); return false; }
  }, []);

  useEffect(() => {
    if (!window.location.pathname.startsWith("/nexus")) { setUser(false); return; }
    if (!localStorage.getItem("nexus_token")) { setUser(false); return; }
    refresh();
  }, [refresh]);

  const login = useCallback(async (email, password) => {
    const { data } = await nexusApi.post("/auth/login", { email, password });
    if (data.access_token) {
      localStorage.setItem("nexus_token", data.access_token);
      if (data.kind === "member") localStorage.setItem("surge_token", data.access_token);
    }
    setUser(data);
    return data;
  }, []);

  const logout = useCallback(async () => {
    try { await nexusApi.post("/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem("nexus_token");
    setUser(false);
  }, []);

  const value = useMemo(() => ({ user, login, logout, refresh }), [user, login, logout, refresh]);
  return <NexusContext.Provider value={value}>{children}</NexusContext.Provider>;
}

export const useNexus = () => useContext(NexusContext);
